import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

import Achievement from './components/Achievement';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Home from './components/Home';
import Navbar from './components/Navbar';
import Services from './components/Services';
import About2 from './components/About2';
import Portfolio from './components/Portfolio';

import PerformanceOptimizer from './components/PerformanceOptimizer';


function App() {
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const portfolioRef = useRef(null);
  // const testimonialsRef = useRef(null);
  const achievementRef = useRef(null);
  const contactRef = useRef(null);

  const [activeSection, setActiveSection] = useState('home');

  const sectionRefs = useMemo(() => ({
    home: homeRef,
    about2: aboutRef,
    services: servicesRef,
    portfolio: portfolioRef,
    // testimonials: testimonialsRef,
    achievement: achievementRef,
    contact: contactRef,
  }), []);

  const scrollToSection = useCallback((section) => {
    setActiveSection(section);
    sectionRefs[section]?.current?.scrollIntoView({ behavior: 'smooth' });
  }, [sectionRefs]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      {
        rootMargin: '-10% 0px -80% 0px', // Adjust as needed
        threshold: 0.1,
      }
    );

    Object.keys(sectionRefs).forEach((section) => {
      if (sectionRefs[section].current) {
        observer.observe(sectionRefs[section].current);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, [sectionRefs]);


  return (
    <HelmetProvider>
      <div className="min-h-screen bg-white">
        <PerformanceOptimizer />
        <Navbar scrollToSection={scrollToSection} activeSection={activeSection} />
        <main>
          <div ref={homeRef} id="home"><Home /></div>
          <div ref={aboutRef} id="about2"><About2 /></div>
          <div ref={servicesRef} id="services"><Services /></div>
          <div ref={portfolioRef} id="portfolio"><Portfolio /></div>
          {/*<div ref={testimonialsRef} id="testimonials"><Testimonials /></div>*/}
          <div ref={achievementRef} id="achievement"><Achievement /></div>
          <div ref={contactRef} id="contact"><Contact /></div>
        </main>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;